import React, { Fragment } from "react"
import { Box, Card, TablePagination, useMediaQuery } from "@mui/material"
import { DataGrid } from '@mui/x-data-grid';
import { PAGE_OPTIONS } from "../../enums/dataGridEnums";
import { useTheme } from "@emotion/react";

export const GenericMuiDatagrid = (props) => {
  const {
    height,
    data,
    columns,
    hideFooter,
    total,
    setPagination,
    per_page,
    current_page,
    children
  } = props;

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));

  return (
    <Fragment>
      {isXs ? 
        <Card 
          variant="outlined" 
          sx={{ 
            boxShadow: 'none', 
            padding: '0px', 
            border: `1px solid ${theme.palette.borders.main}`, 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            flexGrow: 1,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", overflowY: "auto"}} >
            {children}
          </Box>
          <Box display={'flex'} alignContent={'flex-end'} justifyContent={'flex-end'}>
            <TablePagination
              labelRowsPerPage="Per page:"
              component="div"
              count={total}
              page={current_page - 1}
              rowsPerPageOptions={PAGE_OPTIONS}
              onPageChange={(event, newPage) => setPagination((prev) => ({ ...prev, page: newPage }))}
              rowsPerPage={per_page}
              onRowsPerPageChange={(event) => setPagination((prev) => ({ ...prev, pageSize: parseInt(event.target.value, 10) }))}
            />
          </Box>
        </Card> : <Box sx={{ height: height ?? "100%"}}>
          <DataGrid
            rows={data ?? []}
            columns={columns}
            pagination={true}
            paginationMode="server"
            disableColumnMenu={true}
            paginationModel={{
              pageSize: per_page,
              page: current_page - 1,
            }}
            onPaginationModelChange={setPagination}
            pageSizeOptions={PAGE_OPTIONS}
            rowCount={total}
            hideFooter={hideFooter}
            checkboxSelection={false}
            disableRowSelectionOnClick
            sx={{
              border: '1px solid #e6ecf1',
              borderRadius: '16px',
              '.MuiDataGrid-filler': {
                background: '#F9FAFB',
                border: 'none !important'
              },
              '.MuiDataGrid-withBorderColor': {
                border: 'none !important'
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 800,
              },
              '.MuiDataGrid-columnHeader': {
                color: '#454F5B',
                fontSize: '14px',
                background: '#F9FAFB',
                padding: '0px 10px',
              },
              '.MuiDataGrid-columnHeader:focus-within': {
                outline: 'none',
              },
              '.MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': {
                display: 'none',
              },
              '.MuiDataGrid-columnSeparator': {
                display: 'none !important',
              },
              '& .MuiDataGrid-cell': {
                fontSize: '14px',
                border: 'none'
              },
              '.MuiDataGrid-cell:focus-within': {
                outline: 'none',
              },
              '& .MuiDataGrid-row': {
                padding: '0px 5px',
                borderBottom: '1px solid #f5f6f7'
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: 'background.lightBlue',
                transition: '0.5s'
              },
              '& .MuiDataGrid-filler': {
                '--rowBorderColor': 'none !important'
              }
            }}
          />
        </Box>
      }
    </Fragment>
  )
};